// extracted by mini-css-extract-plugin
module.exports = {"FeaturesSlice":"styles_FeaturesSlice__20j03","title":"styles_title__MCJrf"};